const Sortable = () => {
  return import(
    /* webpackChunkName: "sortable" */
    'sortablejs');
}

export default Sortable;
